"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _createFocusRingStyles = require("../../util/createFocusRingStyles");
var _inputFieldBaseProps = require("../../util/inputFieldBaseProps");
var _clickable = require("../clickable");
var _StyledSearchInputComponents = require("./styled/StyledSearchInputComponents");
var _formInputTheme = require("./styled/formInputTheme");
const searchIcon = (0, _sdsThemeInternal.themed)({
  rest: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_StyledSearchInputComponents.StyledLodestarSearchIcon, {
      size: "small",
      color: (0, _designTokensReact.color)("color--icons--neutral--stronger")
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_StyledSearchInputComponents.StyledUrsaSearchIcon, {
      size: 24,
      color: (0, _designTokensReact.color)("color--text--neutral--weaker")
    })
  },
  hover: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_StyledSearchInputComponents.StyledLodestarSearchIcon, {
      size: "small",
      color: (0, _designTokensReact.color)("color--icons--neutral--strongest")
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_StyledSearchInputComponents.StyledUrsaSearchIcon, {
      size: 24,
      color: (0, _designTokensReact.color)("color--text--neutral--weak")
    })
  }
});
const clearIcon = (0, _sdsThemeInternal.themed)({
  rest: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.DeleteIcon, {
      size: "small",
      color: (0, _designTokensReact.color)("color--icons--neutral--stronger")
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.CloseIcon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--text--neutral--weaker")
    })
  },
  hover: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.DeleteIcon, {
      size: "small",
      color: (0, _designTokensReact.color)("color--icons--neutral--strongest")
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.CloseIcon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--text--neutral--weak")
    })
  }
});

// Reserving namespace for consistency.

const ClearSearchButton = _ref => {
  let {
    inputFieldHeight,
    isDisabled,
    isHovered,
    onClick,
    value
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const onClickedCallback = (0, _react.useCallback)(e => {
    if (isDisabled) {
      return;
    }
    onClick(e);
  }, [isDisabled, onClick]);
  if (value === "") {
    return null;
  }
  const IconComponent = isHovered ? clearIcon.hover(themeMode) : clearIcon.rest(themeMode);
  return /*#__PURE__*/_react.default.createElement(_StyledSearchInputComponents.StyledButton, {
    inputFieldHeight: inputFieldHeight,
    isDisabled: isDisabled,
    "aria-label": "clear",
    type: "button",
    themeMode: themeMode,
    onClick: onClickedCallback
  }, IconComponent);
};
const SearchInput = /*#__PURE__*/(0, _react.forwardRef)((props, parentRef) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    inputFieldHeight: inputFieldHeightProp,
    contentAfterButtonProps,
    contentBeforeButtonProps,
    isDisabled = false,
    onChange,
    value
  } = props;
  const inputFieldHeight = (0, _inputFieldBaseProps.getInputFieldHeightValue)(themeMode, inputFieldHeightProp);
  const contentAfterButtonClick = contentAfterButtonProps?.onClick;
  return /*#__PURE__*/_react.default.createElement(_StyledSearchInputComponents.StyledTextInput, (0, _extends2.default)({
    type: "search",
    contentBefore: _ref2 => {
      let {
        isHovered
      } = _ref2;
      const icon = isHovered ? searchIcon.hover(themeMode) : searchIcon.rest(themeMode);
      if (contentBeforeButtonProps !== undefined) {
        return /*#__PURE__*/_react.default.createElement(_clickable.Clickable, (0, _extends2.default)({}, contentBeforeButtonProps, {
          focusRingOptions: {
            colorOverride: _createFocusRingStyles.focusRingTheme.outerColor(themeMode),
            radius: _formInputTheme.formInputTheme.searchInputButtonRadius(themeMode)
          }
        }), icon);
      } else {
        return icon;
      }
    },
    contentAfter: _ref3 => {
      let {
        isHovered
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement(ClearSearchButton, {
        inputFieldHeight: inputFieldHeight,
        value: value,
        isDisabled: isDisabled,
        isHovered: isHovered,
        onClick: e => {
          onChange("", e);
          if (contentAfterButtonClick != null) {
            contentAfterButtonClick(e);
          }
        }
      });
    },
    ref: parentRef
  }, props));
});
exports.SearchInput = SearchInput;
SearchInput.displayName = "SearchInput";
//# sourceMappingURL=SearchInput.js.map